import { render, staticRenderFns } from "./SelectUserInput.vue?vue&type=template&id=ff9885f8&"
import script from "./SelectUserInput.vue?vue&type=script&lang=js&"
export * from "./SelectUserInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports